import {getLocalizationBasedOnLang} from '../../data/models/User/UserInfo';

const english = {
  title: 'Edit video',
  preview: 'Preview',
  back: 'Back',
  tipHeader: 'Instructions',
  tip1: 'The <strong>"Add video"</strong> button lets you pick media from your library or generate AI images and clips.',
  tip2: '<strong>Edit the script</strong> to change the audio connected your chosen segment. You can adjust the content, language and narration settings.',
  tip3: '<strong>Regenerate</strong> reprocesses only the selected clip based on its linked page.',
  tip4: '<strong>Mute audio</strong> hides the sound for that segment.',
  editVideoOptions_EditScript: 'Edit script',
  editVideoOptions_MuteAudio: 'Mute audio',
  editVideoOptions_Regenerate: 'Regenerate',
  editVideoOptions_Delete: 'Delete',
  emptyChunkPreview: 'No clip selected for preview',
  stateRegenerating: 'Regenerating video',
  stateMutingAudio: 'Muting audio',
};

const welsh = {
  title: 'Golygu Ffynhonnell y Fideo',
  preview: 'Rhagolwg',
  back: 'Yn ôl',
  tipHeader: 'Cyfarwyddiadau',
  tip1: 'Mae’r botwm <strong>"Ychwanegu fideo"</strong> yn eich galluogi i ddewis cyfryngau o’ch llyfrgell neu gynhyrchu delweddau a clipiau AI.',
  tip2: '<strong>Golygu’r sgript</strong> i newid y sain sy’n gysylltiedig â’r segment a ddewiswyd. Gallwch addasu’r cynnwys, y iaith a’r gosodiadau darllen.',
  tip3: '<strong>Ailgynhyrchu</strong> yn ailbrosesu dim ond y clip a ddewiswyd yn seiliedig ar ei dudalen gysylltiedig.',
  tip4: '<strong>Mute audio</strong> yn cuddio’r sain ar gyfer y segment hwnnw.',
  editVideoOptions_EditScript: 'Golygu sgript',
  editVideoOptions_MuteAudio: 'Mute audio',
  editVideoOptions_Regenerate: 'Ailgynhyrchu',
  editVideoOptions_Delete: 'Dileu',
  emptyChunkPreview: 'Dim darn wedi’i ddewis ar gyfer rhagolwg',
  stateRegenerating: 'Ail-greu fideo',
  stateMutingAudio: 'Tawelu sain',
};

export const VideoEditorText: any = getLocalizationBasedOnLang(english, welsh);
